export const FxSliderValueMode = {
  'TRUE_LOCK': { disabled: true, value: true },
  'TRUE_UNLOCK': { disabled: false, value: true },
  'FALSE_LOCK': { disabled: true, value: false },
  'FALSE_UNLOCK': { disabled: false, value: false }
};
